@if (label) {
  <div class="label">{{ label }}</div>
}

<section>
  <mat-slider [step]="step" [min]="min" [max]="max" [disabled]="disabled">
    <input matSliderThumb [value]="sliderValue" (input)="inputChange($event)" />
  </mat-slider>

  @if (disabled && showUpgradeTagWhenDisabled) {
    <div class="upgrade-tag-wrapper">
      <la-upgrade-tag></la-upgrade-tag>
    </div>
  } @else {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <input
        matInput
        class="input-field"
        type="number"
        min="{{ min }}"
        max="{{ max }}"
        step="{{ step }}"
        [value]="sliderValue"
        [disabled]="disabled"
        (keydown)="onKeyDown($event)"
        (input)="onInputChange($event)"
        (paste)="onPaste($event)"
      />

      @if (suffix) {
        <span matTextSuffix [ngClass]="{ 'suffix-disabled': disabled }">{{ suffix }}</span>
      }
    </mat-form-field>
  }
</section>
